import React, { useMemo } from 'react';
import { KeyMetricChartData } from 'src/components/organisms/KeyMetricChart';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { calculateTrendFromTimeSeries } from 'src/features/MM/utils/calculateTrendFromTimeSeries';
import { useKpiUnit } from 'src/hooks/useKpiUnit';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricItem } from 'src/features/MM/components/molecules/KeyMetricItem';
import { Icon } from 'src/components/atoms/Icon';

type IncrementalSalesProps = {
  aggregateLevel: AggregateLevel;
};

export const IncrementalSales: React.FC<IncrementalSalesProps> = ({
  aggregateLevel,
}) => {
  const { decomps } = useMMDataContext();

  const { isEuro } = useKpiUnit();
  const keyMetricData: KeyMetricChartData = useMemo(() => {
    return {
      isLoading: decomps.isLoading,
      isError: decomps.isError,
      name: 'Incremental sales',
      isEuro,
      summaryValue: decomps.total,
      data: getAggregateLevelData(decomps, aggregateLevel),
    };
  }, [decomps, isEuro, aggregateLevel]);

  const { upOrDown, upOrDownValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricItem
      title="Incremental Sales"
      upOrDown={upOrDown}
      upOrDownValue={upOrDownValue}
      value={keyMetricData.summaryValue}
      icon={<Icon iconName="hand-with-coin" />}
    />
  );
};
